import { render } from "./AreasListing.vue?vue&type=template&id=7ef63f66&ts=true"
import script from "./AreasListing.vue?vue&type=script&lang=ts"
export * from "./AreasListing.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/lmd-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__